var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "order-select-box" }, [_c('el-select', _vm._g({ attrs: { "placeholder": _vm.config.placeholder }, on: { "change": _vm.handleChange }, model: { value: _vm.orderSelect, callback: function callback($$v) {
        _vm.orderSelect = $$v;
      }, expression: "orderSelect" } }, _vm.$listeners), _vm._l(_vm.config.field.options, function (item) {
    return _c('el-option', { key: item.value, attrs: { "label": item.label, "value": item.value } });
  }), 1), _vm._v(" "), _c('div', { staticClass: "order-icon", on: { "click": _vm.changeOrder } }, [_c('svg-icon', { attrs: { "size": 20, "icon-class": _vm.order === 'descending' ? 'descending_order' : 'ascending_order' } })], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };